export function formatFileSize(size: number) {
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let i = 0;
  while (size >= 1024) {
    size /= 1024;
    ++i;
  }
  return `${size.toFixed(2)} ${units[i]}`;
}

export function isEmbedded() {
  return window !== window.parent;
}

export function isArrayEquals(arr1: any[], arr2: any[]) {
  return arr1.length === arr2.length && arr1.every((el, i) => el === arr2[i]);
}

export type MessageTypeType = 'info' | 'success' | 'warning' | 'error';

interface MessageType {
  alert?: { message: string; type: MessageTypeType };
  event: 'back' | 'navigate' | 'window-resize';
  payload: any;
}

function isValidOrigin(origin: string) {
  return (
    /^https:\/\/im360.*\.crm\d?\.dynamics\.com/.test(origin) ||
    /^https?:\/\/.*\.ingrammicro\.com/.test(origin)
  );
}

export function dispatchToParent(message: MessageType) {
  if (!isEmbedded()) {
    console.warn('Not embedded in iframe');
    return;
  }
  const referrer = window.document.referrer;

  const origin = referrer && isValidOrigin(referrer) ? referrer : null;
  if (!origin) {
    console.error('Invalid Parent Origin', referrer);
    return;
  }
  window.parent.postMessage(message, origin);
}

export function formatObjectKeys<
  TO = Record<string, any>,
  TI = Record<string, any>
>(obj: TI, formatter: (s: string) => string) {
  return Object.entries(obj as any).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [formatter(key)]: value,
    }),
    {}
  ) as TO;
}

export declare enum Severity {
  ERROR = 'error',
  INFO = 'info',
  NONE = '',
  SUCCESS = 'success',
  WARNING = 'warning',
}
